var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.85799 1.77391C5.401 3.84348 3.39536 5.91304 1.38972 10.3478C-1.28448 16.187 -0.0216629 23.8739 4.50961 28.7522C6.96095 31.413 13.0522 34 16.9149 34C20.7776 34 26.8688 31.413 29.3202 28.7522C31.8458 26.0174 34 20.6217 34 17C34 13.1565 31.4001 7.09565 28.7259 4.65652C25.9774 2.14348 20.5548 0 16.9149 0C14.9092 0 12.0865 0.739128 9.85799 1.77391ZM23.229 2.88261C28.8745 5.39565 32.5143 11.2348 32.5143 17.7391C32.5143 20.7696 30.063 26.4609 28.503 27.0522C27.9088 27.2739 25.9031 26.7565 24.0461 25.9435C20.1833 24.2435 19.8119 23.1348 22.1147 19.3652C23.7489 16.7783 24.1946 9.83043 22.8575 7.46522C21.0747 4.06522 13.5721 3.69565 11.3437 6.87391C9.63514 9.23913 9.85799 16.4087 11.7151 19.3652C14.0178 23.1348 13.6464 24.2435 9.78371 25.9435C7.92663 26.7565 5.92099 27.2739 5.32672 27.0522C3.61821 26.387 1.31543 20.6957 1.31543 17.1478C1.24115 5.98696 13.1264 -1.7 23.229 2.88261Z",
    fill: "#3B457B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.d810a1a8997ff795e787ee61fc9deadb.svg";
export { ForwardRef as ReactComponent };